declare var angular: any;
import * as _ from 'underscore';

angular.module('UserExamControllers')

  .service('examUtils', ['trainingUtils', '$mdDialog', 'EXAM', function(trainingUtils, $mdDialog, EXAM) {

    // Need to integrate the good answer because answers come late
    // to prevent cheat
    this.integrateAnswers = function(supports, correction) {
      var part = ['listening', 'reading'];
      for (var p = 0; p < part.length; p++) {
        var LR = part[p];
        // support
        for (var i = 0; i < supports[LR].length; i++) {
          // questions
          for (var k = 0; k < supports[LR][i].questions.length; k++) {
            var questionId = supports[LR][i].questions[k].id;
            var questionAnswer = correction[questionId];

            // choices
            for (var l = 0; l < supports[LR][i].questions[k].choices.length; l++) {
              // integrate
              if (questionAnswer == supports[LR][i].questions[k].choices[l].id) {
                supports[LR][i].questions[k].choices[l].is_correct = true;
              } else {
                supports[LR][i].questions[k].choices[l].is_correct = false;
              }
            }
          }
        }
      }
    };

    this.integrateCurrentAnswers = function(supports, answers) {
      let answersByQuestionsId = _.groupBy(answers, 'question_id');
      var questions = _.flatten(_.map(supports, function (support: any) {return support.questions}));
      Object.keys(answersByQuestionsId).forEach(questionId => {
        let answerByQuestionId = _.sortBy(answersByQuestionsId[questionId], 'id');
        let question = _.find(questions, (question) => questionId == question.id);
        question.choice_user = _.last<any>(answerByQuestionId).choices[0].id;
      });
    };


    this.getUsersAnswersInput = function(answers) {
      let userAnswersInput = {};

      answers.forEach(answer => {
        if (answer?.extra_value) {
          userAnswersInput[answer.question_id] = answer?.extra_value;
        }
      });

      return userAnswersInput;
    }

    // correctUSerChoices
    this.correctAnswers = function(supports) {
      // This is for feedback
      var results = {
        "goodAnswers": 0,
        "badAnswers": 0
      };

      var part = ['listening', 'reading'];

      for (var p = 0; p < part.length; p++) {
        var LR = part[p];

        // support
        for (var i = 0; i < supports[LR].length; i++) {
          var g_results = results.goodAnswers;
          trainingUtils.correctAnswers(supports[LR][i], results);
          supports[LR][i].nbGoodAnswer = results.goodAnswers - g_results;
        }

      }

      return results;
    };

    /*
    data: {
    supports :
    support: to integrate in loop
    currentPart: need global var with support
    }
    */
    // TODO make function to refactor
    this.showHelp = function(data) {
      //console.log(data);
      if (data.supports) {
        var currentPart;
        for (var i = 0; i < data.supports.length; i++) {
          var show = (data.supports[i].part != currentPart);
          if (show) data.supports[i].showHelp = true;
          currentPart = data.supports[i].part;
        }
      }
      if (data.support){
        var show = (data.support.part != data.currentPart);
        data.currentPart = data.support.part;
        if (show) data.support.showHelp = true;
        return data.currentPart;
      }
    };

    /*
    data: {
    support: to integrate in loop
    index: need global var
    }
    */
    this.indexQuestionsSupport = function(data){
      if (data.index === undefined) {
        data.index = 1;
      }
      for (var j = 0; j < data.support.questions.length; j++) {
        if (!(EXAM === 'lerobert' && data.support.part >= 13 && j >= 1)) {
          data.support.questions[j].index = data.index;
          data.index++;
        }
      }
      return data.index;
    };

    this.showScore = function(ev, $scope) {
      $mdDialog.show({
        clickOutsideToClose: true,
        preserveScope: true,
        parent: angular.element(document.body),
        templateUrl: '/ng1/www/modules/user/practice/exam/html/score_dialog.html',
        scope: $scope, // use parent scope in template
        //preserveScope: true,

        openFrom: {
          top: -50,
          width: 30,
          height: 80
        },
        closeTo: {
          left: 50
        },

        controller: ["$scope", "$mdDialog", function finishedDialog($scope, $mdDialog) {
          $scope.close = function() {
            $mdDialog.cancel();
          };
        }]
      });
    };

  }
  ])


  .service('audio', ['angularPlayer', '$window', function(angularPlayer, $window) {

    var volume;

    this.init = function(gap, autoLoad) {
      angularPlayer.init(gap, autoLoad);
    };

    // audioType = training | exam
    this.convertToTrack = function(id, file) {
      var song = {
        url: file,
        id: id,
        title: id,
        artist: id
      };
      return song;
    };

    // Load an exam
    this.setPlaylist = function(supports, audioType) {
      var songs = [];

      for (var i = 0; i < supports.length; i++) {
        if (supports[i].training_audio) {

          var song = this.convertToTrack(supports[i].id, supports[i][audioType + "_audio"]);
          songs.push(song);

        }

      }
      return songs;
    };

    this.getPlaylist = function() {
      return angularPlayer.getPlaylist();
    };


    this.addTracks = function(songs) {
      for (var i = 0; i < songs.length; i++) {
        angularPlayer.addTrack(songs[i]);
      }

      if (songs.length) {
        angularPlayer.setCurrentTrack(songs[0].id);
      }
    };

    // especially for training
    this.loadOneTrack = function(song, playAfterLoad) {
      angularPlayer.stop();
      angularPlayer.clearPlaylist(function() {
        angularPlayer.addTrack(song);
        angularPlayer.setCurrentTrack(song.id);
        if (playAfterLoad) {
          angularPlayer.play();
        }
      });
    };

    this.goToCurrent = function(id) {
      angularPlayer.setCurrentTrack(id);
    };

    this.play = function() {
      angularPlayer.play();
    };

    this.pause = function() {
      angularPlayer.pause();
    };

    this.stop = function() {
      angularPlayer.stop();
      if (angularPlayer.getPlaylist().length) {
        angularPlayer.clearPlaylist(function() {});
      }
    };

    this.getVolume = function() {
      if (volume === undefined) {
        return ($window.localStorage.volume) ? parseInt($window.localStorage.volume) : angularPlayer.getVolume();
      } else {
        return volume;
      }
    };

    this.setVolume = function(value) {
      volume = value;
      $window.localStorage.volume = value;
      angularPlayer.adjustVolumeSlider(value);
    };

  }
  ]);
